var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "ee92f92a4b068636b9212d73cda41ea5.png",
    width: 327,
    height: 72
});